$(function() {
  function check_image_swap() {
    if ((window_size < 768) && !images_swapped) {
      //if the window is less than 768, swap the image src for mobile
      images_swapped = true;
      $('.guide-preview').each(function() {
        $(this).attr('src', $(this).data('mobile-image'));
      });
    } else if ((window_size >= 768) && images_swapped) {
      //if the window is greater than 768, swap the image src for standard, but only if already swapped
      images_swapped = false;
      $(this).attr('src', $(this).data('standard-image'));
    }
  }

  function replaceImage($element) {
    var missingImagePath = $element.data('error');
    $element.replaceWith(`<img src='${missingImagePath}' class="image-preview">`);
  }

  if ($('.image-preview, .video-preview').length > 0) {
    var window_size = $(window).width();
    var images_swapped = false;

    $('img.image-preview').on('error', function() {
      replaceImage($(this));
    });

    $('video.video-preview source').on('error', function() {
      replaceImage($(this).closest('video'));
    });

    $(window).on('resize', function() {
      window_size = $(window).width();
      check_image_swap(window_size);
    });

    check_image_swap();
  }
});
